import { css, type Theme } from "@emotion/react";

import * as animations from "@styles/emotion-styles/animations";
import * as layers from "@styles/emotion-styles/layers";
import * as timing from "@styles/emotion-styles/timing";

export const searchModal = {
  base: (theme: Theme) => css`
    transition: all ${timing.defaultTiming} ${animations.easeOutCubic};
    background-color: ${theme.surface.level1};
    opacity: 0;
    width: calc(100% - 2rem);
    pointer-events: none;

    position: fixed;
    top: -20rem;
    left: 0px;
    height: 4rem;
    z-index: ${layers.indexModalMax};
    display: flex;
    align-items: center;
    padding: 0 1rem;
    gap: 1rem;
  `,
  active: css`
    top: 0;
    opacity: 1;
    pointer-events: all;
  `,
};
